import useAuth from "../../hooks/useAuth";

export default function Home() {
  const { auth, isUserLogged } = useAuth();
  if (isUserLogged()) {
    return <h1>Bienvenido {auth!.username}</h1>;
  }
  return <h1>Identifiquese, por favor</h1>;
}
